module.exports = __webpack_public_path__ + "static/media/banner-shelfzone.48fa52a3.jpg";